import { icons } from "./images";

const sideBarData = [
  {
    label: "Dashboard",
    to: "/dashboard",
    image: icons.fbIcon,
  },
];

const mediaLogo = (media) => {
  switch (media) {
    case "FACEBOOK":
      return icons.Facebook;
    case "INSTAGRAM":
      return icons.Insta;
    case "YOUTUBE":
      return icons.YouTube;
    case "TWITTER":
      return icons.Twitter;
    case "QUORA":
      return icons.Quora;
    default:
      return null;
  }
};

const purchaseStatus = {
  ALREADY_PURCHASED: "ALREADY_PURCHASED",
  NOT_PURCHASED: "NOT_PURCHASED",
  UPGRADABLE: "UPGRADABLE",
  ALREADY_PURCHASED_BETTER_PLAN: "ALREADY_PURCHASED_BETTER_PLAN",
};

const planStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  FREE: "FREE",
};

const announcementHeader = ["Counselling", "News", "Details", "Links"];

const eventsHeader = ["Counselling", "Event Description", "Date"];

const repoMapping = {
  allotments: "Allotments",
  closingranks: "Closing Ranks",
  seatmatrix: "Seat Matrix",
  feestipendbond: "Fee, Stipend and Bond",
  choiceTable: "My Choice List",
  allotmentmapping: "Allotment Mapping",
  rankscan: "Rank Scan",
};

export {
  eventsHeader,
  announcementHeader,
  planStatus,
  purchaseStatus,
  mediaLogo,
  sideBarData,
  repoMapping,
};
